import { updatePreferences } from 'store/Preferences/actions';
import { buildSeenReleases } from './helpers';
import { selectWhatsNewSeenReleasesFromPreferences } from './selectors';

// eslint-disable-next-line import/prefer-default-export
export function markWhatsNewReleasesSeen (versionIds, seenVersionIds) {
  return (dispatch) => dispatch(updatePreferences((preferences) => {
    const storedSeenReleases = selectWhatsNewSeenReleasesFromPreferences(preferences);
    const seenReleases = buildSeenReleases(versionIds, storedSeenReleases).map((release) => (
      seenVersionIds.includes(release.version) ? { ...release, seen: true } : release
    ));

    return { whats_new: { seen_releases: seenReleases } };
  }));
}
